import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../lib/axios';


export const getCampaignAnalytics = createAsyncThunk('broadcastAnalytics/getCampaignAnalytics', async (projectId, { rejectWithValue }) => {
    try {
        const response = await api.get('/api/campaign-analytics', { params: { projectId } });
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.message);
    }
})